<template>
  <div :style="areaStyle">
    <div class="article-content-container">
      <div class="article-content-header"
           :style="{'display': isTitle && 'none'}"
      >
        <h2 class="article-title" v-if="articleContentData.articleTitleStatus">
          {{ articleData.articleTitle }}
        </h2>
        <div class="article-other">
        <span class="article-time" v-if="articleContentData.releaseTimeStatus">
          {{articleData.publishTime
          }}</span>
          <span class="article-read" v-if="articleContentData.readingStatus">
          <img :src="iconEye" class="icon-eye" />{{articleData.readNum ? articleData.readNum : 0
            }}</span>
        </div>
      </div>
      <div class="article-content" :class="{'no-border': isTitle}" v-if="articleData && articleData.content && !isVideoArticle" v-html="articleData.content"></div>
      <div class="article-content" :class="{'no-border': isTitle}" v-if="isVideoArticle">
        <VideoComp :videoUrl="articleData && articleData.articleVideoUrl" style="height: auto;" />
      </div>
    </div>
    <div v-if="articleData && articleData.copyrightType==1" class="article-source">
      <div class="oneItem">文章来源: {{articleData.source}}</div>
      <div class="oneItem">版权归原作者所有，如有侵权请联系我们删除</div>
    </div>
    <div class="placeholder-img" v-if="Object.keys(articleData).length == 0">
      <img src="http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325879805.png" alt="">
    </div>
    <div>
    </div>
    <div v-if="articleData.enclosureJson">
      <div  class="fujianItem" v-for="(item, index) in JSON.parse(articleData.enclosureJson)" :key="index" v-show="item.name">
        <div class="fujianItemLeft">
          <p class="fujianTitle fl">附件：</p>
          <p class="yasuobaoTitleh5 fl">
            <span>{{ item.name }}</span>
            <!--              <span>{{ allArticleData.enclosureSize }}MB</span>-->
          </p>
        </div>
        <div class="fujianItemRight fr">
          <a
            :href="item.url"
            class="fujianDownload"
            target="_blank"
            v-if="suffixFilter(item.name)"
          >预览</a
          >
          <span class="fujianDownload" v-else @click="handleDownload(item.url,item.name)">下载</span>
        </div>
      </div>
    </div>
    <div v-show="articleData.externalName" class="fujianItem friendLinkItem">
      <div class="fujianItemLeft">
        <p class="fl">相关链接：</p>
        <p class="yasuobaoTitleh5 renliziyuankiaoshiLink fl">
          <span>{{ articleData.externalName }}</span>
        </p>
      </div>
      <div class="fujianItemRight fr">
        <a
          :href="articleData.externalUrl"
          class="lijiqianwang"
          target="_blank"
        >立即前往</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import iconEye from '../asset/images/icon-eye.png'
export default {
  name: "articleContent",
  data() {
    const { tempData: { specialData, specialStyle, articleContentData } } = this.data
    return {
      iconEye,
      specialData,
      specialStyle,
      articleContentData,
      articleData: {},
      isShow: true
    }
  },
  props: {
    data: {
      type: Object
    },
  },
  components: {
    VideoComp: ()=>import('./videoComponent/video.vue')
  },
  computed: {
    isVideoArticle(){
      return this.articleData && this.articleData.articleType == 2 ? true : false
    },
    isTitle(){
      const { articleTitleStatus, releaseTimeStatus, readingStatus } = this.articleContentData
      return !articleTitleStatus && !releaseTimeStatus && !readingStatus
    },
    areaStyle(){
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor
      } =  this.specialStyle;
      return {
        marginTop: `${blockMargeTop?blockMargeTop:0}px`,
        marginBottom: `${blockMargeBottom?blockMargeBottom:0}px`,
        backgroundColor: blockBGClolor?blockBGClolor:'none',
      }
    },
  },
  methods: {
    async getArticleDetail(){
      const { articleId } = this.articleContentData
      articleId && this.$apis.cms.getArticleDetail({
        articleId,
        readTag:1,
        pageNum:1,
        pageSize:10000
      }).then(res=>{
        this.articleData = res.data.list[0]
      })
    },
    suffixFilter (msg) {
      const suffix = msg.lastIndexOf('.');
      return msg.slice(suffix+1) == 'pdf' ? true : false
    },
     handleDownload(imgUrl) {
      console.log(imgUrl)
      // fetch(imgUrl, {
      //   method: "get",
      //   headers: new Headers({
      //     Origin: location.origin
      //   }),
      //   mode: "cors",
      // }).then((res) =>
      //   res.blob().then((blob) => {
      //     var reader = new FileReader();
      //     reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
      //     reader.onload = function (e) {
      //       var down = document.createElement("a"); // 转换完成，创建一个a标签用于下载
      //       down.download = name;
      //       down.href = String(e.target.result);
      //       down.click();
      //       down.remove();
      //     };
      //   })
      // );
      this.$toast({ type: 'primary', message: '请前往电脑端下载' });
    }
  },
  mounted(){
    this.getArticleDetail()
  }
};
</script>
<style lang="less" scoped>
@import "../asset/articleDetail.css";
.fujianItem {
  padding: 0 20px;
  margin-bottom: 24px;
  box-sizing: border-box;
}
.oneItem{
  height: 40px;
  line-height: 40px;
}
.placeholder-img {
  img {
    width: 100%;
  }
}
.article-source{
  width: 100%;
  text-align: left;
  margin: 24px 12px;
  padding: 24px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  color: #999999;
  font: 400 12px/.5em PingFangSC-Regular, PingFang SC;
}
.article-content-container {

  .article-content-header {
    padding: 24px;
    box-sizing: border-box;
  }
  .article-title {
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .article-other {
    margin-top: 12px;
    line-height: 36px;
  }
  .article-content {
    border-top: 1px solid #D6DEEA;
    padding: 24px;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 36px;
    &.no-border{
      border-top: none;
    }
    /deep/img{
      width: 100%;
      height: auto;
    }
  }
  .article-time,.article-read{
    font-size: 24px;
    font-weight: 400;
    color: #999;
  }
  .article-read{
    color: #666;
    margin-left: 48px;
  }
  .icon-eye{
    width: 36px;
    height: 36px;
    margin-right: 12px;
    vertical-align: -8px;
  }
}
</style>
